var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "p",
      [
        _c("Loader", {
          attrs: {
            showAnimation: _vm.downloading,
            msg: _vm.downloading
              ? "Descarga en ejecución. Por favor, espere..."
              : _vm.error
              ? "Ha ocurrido un error. Por favor, inténtelo de nuevo. Si el problema persiste, por favor contacte con el administrador web."
              : "Descarga terminada. Puede cerrar esta pestaña del navegador.",
            fullPage: ""
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Download.vue?vue&type=template&id=85f5b17a&
// module id = null
// module chunks = 